import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuUsuario extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/usuario/consulta" className="nav-link">
          <i className="link-icon icon-user" />
          <span className="menu-title">Usuário</span>
          <i className="menu-arrow" />
        </Link>
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/usuario/consulta">
                Consultar
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={{ pathname: "/usuario/cadastro", state: "refresh" }}>
                Novo Cadastro
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/usuario/logs">
                Registros de Acesso
              </Link>
            </li>
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuUsuario;
